<script lang="ts" setup>
import type { AgentOnPage } from '@@/shared/agent/api-types';
import type { TransactionType } from '@@/shared/property/types';
import { TRANSACTION_TYPE } from '@@/shared/property/types';

const props = defineProps<{
  latestTransactions: AgentOnPage['latestTransactions']
  titleTag?: 'p' | 'h2' | 'h3'
}>();

const hasBothTransactions = computed(() => {
  return props.latestTransactions.sold.length > 0 && props.latestTransactions.rented.length > 0;
});
const latestSoldPropertiesTransactionType = ref<TransactionType>(
  props.latestTransactions.sold.length ? TRANSACTION_TYPE.SALE : TRANSACTION_TYPE.RENTAL,
);
</script>

<template>
  <IadWrapper class="py-l md:py-2xl">
    <IadTitle
      :text="$t(`agent.latest_transactions.title`)"
      variant="large"
      class="py-s md:py-m"
      tag="h3"
    />
    <IadRadioGroup
      v-if="hasBothTransactions"
      v-model="latestSoldPropertiesTransactionType"
    >
      <IadRadio
        :label="$t(`core.common.sold.${TRANSACTION_TYPE.SALE}`)"
        :value="TRANSACTION_TYPE.SALE"
      />
      <IadRadio
        :label="$t(`core.common.sold.${TRANSACTION_TYPE.RENTAL}`)"
        :value="TRANSACTION_TYPE.RENTAL"
      />
    </IadRadioGroup>
    <IadScrollable
      :class="{
        '!hidden': latestSoldPropertiesTransactionType === 'rental',
      }"
    >
      <PropertyCardSold
        v-for="property of latestTransactions.sold"
        :key="property.propertyListingRef"
        :property
        :title-tag
        variant="compact"
      />
    </IadScrollable>
    <IadScrollable
      :class="{
        '!hidden': latestSoldPropertiesTransactionType === 'sale',
      }"
    >
      <PropertyCardSold
        v-for="property of latestTransactions.rented"
        :key="property.propertyListingRef"
        :property
        :title-tag
        variant="compact"
      />
    </IadScrollable>
  </IadWrapper>
</template>
